import _typeof from 'babel-runtime/helpers/typeof';
import invariant from './invariant';

/**
 * @var {Array.<string>}
 */
export var defaultVendors = ['webkit', 'moz', 'ms', 'o'];

/**
 * @param {object} context
 * @param {string} propName
 * @param {Array<string>} [vendors=defaultVendors]
 * @returns {string|void}
 */
export function getVendorPropName(context, propName) {
  var vendors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultVendors;

  invariant((typeof context === 'undefined' ? 'undefined' : _typeof(context)) === 'object' && context !== null, 'context expected a non-null object, instead received %s.', context);

  invariant(typeof propName === 'string', 'propName expected a string, instead received %s.', propName);

  invariant(Array.isArray(vendors), 'vendors expected a array, instead received %s.', vendors);

  if (context[propName] !== undefined) {
    return propName;
  }

  var capitalizedPropName = propName.replace(/^./, function (f) {
    return f.toUpperCase();
  });
  var length = vendors.length;


  for (var i = 0; i < length; i++) {
    var vendorPropName = '' + vendors[i] + capitalizedPropName;
    if (context[vendorPropName] !== undefined) {
      return vendorPropName;
    }
  }

  return undefined;
}

/**
 * @param {object} context
 * @param {string} propName
 * @param {Array<string>} [vendors=defaultVendors]
 * @returns {any}
 */
function getVendorProp(context, propName) {
  var vendors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultVendors;

  var vendorPropName = getVendorPropName(context, propName, vendors);

  if (vendorPropName !== undefined) {
    return context[vendorPropName];
  }

  return undefined;
}

export default getVendorProp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/utils/getVendorProp.js
// module id = 309
// module chunks = 0